interface MarianaConfig {
  bffUrl: string;
  messages?: {
    initialMessage?: string;
    colInitialMessage?: string;
    genericErrorMessage?: string;
    offlineNetworkMessage?: string;
  };
  tooltip?: {
    message?: string;
    timeout?: number;
  };
  assets?: {
    amenityIcons?: Record<string, string>;
    brandLogos?: Record<string, string>;
    defaultStoreImage?: string;
  };
}

let loaded = false;

export const config = {
  BFF_URL: '',
  MESSAGES: {
    INITIAL_MESSAGE:
      'Olá, sou a Mariana, a assistente virtual do Continente. Estou aqui para lhe prestar apoio com base em inteligência artificial. As respostas não substituem informação oficial nem têm valor vinculativo.\nComo posso ajudar?😊',
    COL_INITIAL_MESSAGE:
      'Olá, sou a Mariana, a assistente virtual do Continente. Estou aqui para lhe prestar apoio com base em inteligência artificial. As respostas não substituem informação oficial nem têm valor vinculativo.\nPode escrever a sua questão ou selecionar uma das opções abaixo. 😊',
    GENERIC_ERROR_MESSAGE: 'Desculpe, ocorreu um problema técnico. Por favor, tente novamente mais tarde.',
    OFFLINE_NETWORK_MESSAGE: 'Sem ligação à rede. Verifique a sua ligação à internet.',
  },
  TOOLTIP: {
    MESSAGE: 'Olá, Sou a Mariana! Posso ajudar? 👋',
    TIMEOUT: 5000,
  },
  ASSETS: {
    AMENITY_ICONS: {} as Record<string, string>,
    BRAND_LOGOS: {} as Record<string, string>,
    DEFAULT_STORE_IMAGE: '',
  },

  get SESSIONS_URL(): string {
    return `${this.BFF_URL}/chat/sessions`;
  },
  get RECONNECT_URL(): string {
    return `${this.BFF_URL}/chat/sessions/reconnect`;
  },
};

/**
 * Loads the runtime configuration from config.json (located next to the script on the CDN).
 * Must be called once before any BFF call.
 */
export async function loadConfig(): Promise<void> {
  if (loaded) return;

  // Resolve config.json: use the script's own URL in production (CDN),
  // fall back to the page origin in dev (Vite serves public/ at root)
  const scriptUrl = document.querySelector('script[src*="mariana"]')?.getAttribute('src');
  const baseUrl = scriptUrl
    ? new URL('.', new URL(scriptUrl, document.baseURI)).href
    : new URL('/', document.baseURI).href;
  const configUrl = `${baseUrl}config.json`;

  const resp = await fetch(configUrl);
  if (!resp.ok) {
    throw new Error(`[MarianaWidget] Failed to load config.json from ${configUrl} (${resp.status})`);
  }

  const json: MarianaConfig = await resp.json();

  if (!json.bffUrl) {
    throw new Error('[MarianaWidget] config.json is missing required field "bffUrl"');
  }

  config.BFF_URL = json.bffUrl;
  if (json.messages?.initialMessage) {
    config.MESSAGES.INITIAL_MESSAGE = json.messages.initialMessage;
  }
  if (json.messages?.colInitialMessage) {
    config.MESSAGES.COL_INITIAL_MESSAGE = json.messages.colInitialMessage;
  }
  if (json.messages?.genericErrorMessage) {
    config.MESSAGES.GENERIC_ERROR_MESSAGE = json.messages.genericErrorMessage;
  }
  if (json.messages?.offlineNetworkMessage) {
    config.MESSAGES.OFFLINE_NETWORK_MESSAGE = json.messages.offlineNetworkMessage;
  }
  if (json.tooltip?.message) {
    config.TOOLTIP.MESSAGE = json.tooltip.message;
  }
  if (json.tooltip?.timeout && Number.isFinite(json.tooltip.timeout) && json.tooltip.timeout > 0) {
    config.TOOLTIP.TIMEOUT = json.tooltip.timeout;
  }
  if (json.assets?.amenityIcons) {
    config.ASSETS.AMENITY_ICONS = json.assets.amenityIcons;
  }
  if (json.assets?.brandLogos) {
    config.ASSETS.BRAND_LOGOS = json.assets.brandLogos;
  }
  if (json.assets?.defaultStoreImage) {
    config.ASSETS.DEFAULT_STORE_IMAGE = json.assets.defaultStoreImage;
  }
  loaded = true;
}
